import { modalActions } from '@/actions';
import Snackbar from '@/components/elements/notifications/Snackbar/Snackbar';
import { loggedUser } from '@/helpers';
import { getGiftcardErrorMessage, trackGiftcardSaveCompleted, trackGiftcardSaveFailed } from '@/helpers/giftcards';
import { _s } from '@/locale';
import { saveGiftcard } from '@/services';
import { AppDispatch } from '@/store';
import { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAppSelector } from '.';
import { LoginContext, LoginContextType } from './useLogin';

export const handleSaveGifcardFromLink = ({
  giftcardToken,
  user,
  dispatch,
  history,
  location,
  loginContext,
}: {
  giftcardToken?: string;
  user?: any;
  dispatch: AppDispatch;
  history: any;
  location: any;
  loginContext: LoginContextType;
}) => {
  if (Boolean(giftcardToken) && !user && !loggedUser()) {
    dispatch(modalActions.login({ show: true, loginContext, initiatedFrom: 'save_giftcard_from_link' }));
  }

  if (user && Boolean(giftcardToken)) {
    saveGiftcard(giftcardToken)
      .then((card) => {
        sessionStorage.setItem('savedGiftcard', 'true');
        history.replace({
          pathname: location.pathname,
        });
        toast(({ closeToast }) => (
          <Snackbar
            type="info"
            label={_s(`saveGiftcard.success`)}
            action={<button onClick={closeToast}>{_s('Alright')}</button>}
          />
        ));
        trackGiftcardSaveCompleted(card);
      })
      .catch((error) => {
        trackGiftcardSaveFailed(error?.message);
        history.replace({
          pathname: location.pathname,
        });
        const errorMessage = getGiftcardErrorMessage(error?.message);
        toast(({ closeToast }) => (
          <Snackbar type="danger" label={errorMessage} action={<button onClick={closeToast}>{_s('Alright')}</button>} />
        ));
      });
  }
};

const useSaveGiftcardFromLink = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const loginContext = useContext(LoginContext);
  const user = useAppSelector((state) => state.users.user);
  const query = new URLSearchParams(location.search);
  const giftcardToken = query.get('giftcardToken');

  useEffect(
    () => handleSaveGifcardFromLink({ giftcardToken, dispatch, history, location, user, loginContext }),
    [giftcardToken, user],
  );
};

export default useSaveGiftcardFromLink;
